import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {RouteId} from 'src/app/enums/env/routes-id-enum';
import {RouteIndicatorResponse} from 'src/app/shared/types/routes/indicator-route.types';
import {StationPriceRepo} from 'src/app/repositories/price/repo/station-price-repo';

export const priceTabIndicatorResolver: ResolveFn<RouteIndicatorResponse> = () => {
  const priceService = inject(StationPriceRepo);
  return {
    [RouteId.STATIONS_LIST_PRICES_REQUESTS]: priceService.errorPricesCount$,
  }
};


